export const CHECKOUT_URL = 'https://pay.hotmart.com/W108004098B?checkoutMode=10'
export const CTA_LABEL = 'Quiero ser Inolvidable'
export const PRICE = '$10 USD'

export const IMAGES = {
  banner: 'https://cdn.magicpatterns.com/uploads/1ba3sbMvW7p6GsreTY2kob/Banner_para_la_pagina.png',
  doc: 'https://cdn.magicpatterns.com/uploads/brviboM8BVueo9yMauHn84/beatriz_en_vertical.png',
  mockup:
    'https://cdn.magicpatterns.com/uploads/wd26vdsErdV6HvkmFitXeT/Kit_de_Curso_Inolvidable_con_Beatriz_Espina.png',
}

/** Paste a video embed URL (YouTube/Vimeo/etc.) to replace the preview placeholder. */
export const VIDEO_URL = ''

export type HeroVariantKey = 'A' | 'B' | 'C'
export type HeroVariant = { title: string; accent: string; subtitle: string }

/** A/B test of the hero promise, selected with ?v=A|B|C (default A). */
export const heroVariants: Record<HeroVariantKey, HeroVariant> = {
  A: {
    title: 'Nadie te enseñó a tocar.',
    accent: 'Hoy sí.',
    subtitle: 'Aprende dónde, cómo y con qué ritmo. Sola, solo o en pareja.',
  },
  B: {
    title: 'Tus manos pueden ser',
    accent: 'inolvidables.',
    subtitle: 'Una clase para tocar con intención, con anatomía real y sin vergüenza.',
  },
  C: {
    title: 'Sal de la rutina.',
    accent: 'Solo con las manos.',
    subtitle: 'Aprendan juntos el mapa del cuerpo y a comunicarse sin pena.',
  },
}

export const transformationRows = [
  {
    before: 'Improvisas y repites lo que alguna vez funcionó.',
    after: 'Tocas con intención: sabes dónde, cómo y cuándo cambiar.',
  },
  { before: 'La rutina decide por ti.', after: 'Tú decides, y sorprendes.' },
  { before: 'Te da pena preguntar.', after: 'Preguntas "¿así o más suave?" sin vergüenza.' },
  {
    before: 'Crees que necesitas juguetes o más tiempo.',
    after: 'Descubres que tus manos son tu mejor herramienta.',
  },
  {
    before: 'No conoces bien tu cuerpo ni el de tu pareja.',
    after: 'Tienes el mapa claro y sabes qué te gusta.',
  },
]

export const offerItems = [
  'La clase completa en video con la DOC',
  '4 módulos con anatomía real',
  'Respuestas a preguntas reales',
  'Guía INOLVIDABLE en PDF',
  'Reto de 7 días',
  'Acceso por 1 año',
]

export const modules = [
  { number: 1, title: 'El Arte del Ritmo', text: 'Aprende a leer el ritmo y la respuesta del cuerpo.' },
  { number: 2, title: 'El Mapa Que Nadie Te Mostró', text: 'Dónde y cómo tocar, con anatomía real.' },
  { number: 3, title: 'El Despertar', text: 'El mapa de la piel que despierta el deseo.' },
  { number: 4, title: 'El Arte de la Confianza', text: 'Seguridad, gradación y comunicación.' },
]

export type Testimonial = { name: string; country: string; quote: string }

/** Add testimonials here. While empty, only the section title is shown. */
export const TESTIMONIALS: Testimonial[] = []

export const faqs = [
  { q: '¿Tengo que tener pareja?', a: 'No. Puedes aprender sola o solo.' },
  { q: '¿Necesito juguetes?', a: 'No. Empiezas con tus manos.' },
  { q: '¿Y si me da vergüenza?', a: 'La ves en privado, a tu ritmo y sin juicios.' },
  {
    q: '¿Es explícita?',
    a: 'Es educación sexual para adultos, con modelos educativos. No se muestran cuerpos reales ni al público.',
  },
  {
    q: '¿Reemplaza una consulta médica?',
    a: 'No. Ante dolor o dudas de salud, consulta a un profesional.',
  },
]
